import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ViewSponsorComponent } from './view-sponsor.component';
import { CommonModule } from '@angular/common';
import { ApplicationFormComponent } from './application-form/application-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
    declarations: [
        ViewSponsorComponent,
        ApplicationFormComponent
    ], 
    imports: [
        CommonModule, 
        ReactiveFormsModule, 
        FormsModule
    ], 
    exports: [
        ViewSponsorComponent
    ], 
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA, 
        NO_ERRORS_SCHEMA
    ]
})
export class ViewSponsorModule {}